
<div class="d-flex justify-content-end mb-5">
  <div class="link-container mr-1" *ngIf="showText">
    <span class="link-text">{{ link }}</span>
  </div>

  <button type="button" class="icon-btn" (click)="showText = !showText" [title]="showText ? 'Hide link' : 'Show link'">
    <i class="fa" [class.fa-eye]="!showText" [class.fa-eye-slash]="showText"></i>
  </button>

  <button type="button" class="icon-btn ml-1" (click)="copyLink()" title="Copy link">
    <i class="fa fa-clipboard"></i>
  </button>
</div>

<div class="manage-users m-auto mt-5">
  <section class="card shadow-sm-darker mb-4">
    <form #addUser="ngForm" name="addUser" (ngSubmit)="inviteStudent()" class="mb-0">
      <h3 class="card-header mb-0">Invite Students</h3>
      <div class="card-body">
        <div class="fieldset w-100 mb-0">
          <label class="legend" for="email">Enter Email <span class="requiredfield">*</span></label>
          <input type="email" class="text-field" ngModel #email name="email" id="email" required>
        </div>
        
      </div>

      <div class="card-footer">
        <button type="submit" [disabled]="!addUser.form.valid || loading" class="btn">Invite User</button>
      </div>
    </form>
  </section>
</div>